<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Area Compagnie', route: '/backoffice/area-compagnie' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AREA COMPAGNIE</h1>
</section>

<section class="px-container pb-4">
    <div class="flex lg:justify-end mb-6">
        <button class="p-3 lg:w-1/6 w-full acc-btn acc-btn-primary text-center" type="button" (click)="documenti = true">Gestisci documenti teatro</button>
    </div>

    <div class="text-center mb-8">
        <ul class="flex flex-wrap justify-center -mb-[2px] divide-x">
            <li class="px-2">
                <span class="tab" (click)="section = 'cruscotto'" [ngClass]="{'tab-active': section == 'cruscotto'}">
                    CRUSCOTTO
                    @if (badgeCrit > 0) { <span class="ac-badge">{{ badgeCrit }}</span> }                    
                </span>
            </li>
            <li class="px-2">
                <span class="tab" (click)="section = 'compagnie'" [ngClass]="{'tab-active': section == 'compagnie'}">
                    COMPAGNIE
                    <span class="ac-badge">{{ summaries.length }}</span>                    
                </span>
            </li>
            <li class="px-2">
                <span class="tab" (click)="section = 'rubrica'" [ngClass]="{'tab-active': section == 'rubrica'}">
                    RUBRICA
                    <span class="ac-badge">{{ rubrica.length }}</span>                    
                </span>
            </li>
        </ul>
    </div>
</section>

@if (loading) {
    <app-loading-backoffice [visible]="true"></app-loading-backoffice>
}

<!-- ============ CRUSCOTTO ============ -->
@if (!loading && section === 'cruscotto') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Prossimi spettacoli · 14 giorni</h2>
        <span class="ac-meta">stato accreditamento · click per aprire</span>
    </div>

    <div class="ac-events-list">
        @for (e of summaries14; track e.id) {
            <button type="button" class="ac-event-row" (click)="openEvento(e.id)">
                <div class="ac-event-date">
                    <strong>{{ e.dal | date: 'dd' }}</strong>
                    <span>{{ e.dal | date: 'MMM' | uppercase }}</span>
                </div>
                <div class="ac-event-title">
                    {{ e.evento }}
                    <span class="sub">{{ e.ragione_sociale }} · {{ e.n_personale }} lavoratori · {{ e.n_subappalti }} subappalti</span>
                </div>
                <div class="ac-status-bar">
                    <div [class]="statusClass(e.status.doc)" title="Documenti">Doc</div>
                    <div [class]="statusClass(e.status.pers)" title="Personale">Pers</div>
                    <div [class]="statusClass(e.status.imp)" title="Impianti">Imp</div>
                    <div [class]="statusClass(e.status.sub)" title="Subappalti">Sub</div>
                </div>
                <div class="ac-event-summary" [ngClass]="e.summary.level">{{ e.summary.text }}</div>
                <div class="ac-event-arrow">→</div>
            </button>
        } @empty {
            <div class="ac-empty">Nessuno spettacolo nei prossimi 14 giorni.</div>
        }
    </div>

    <div class="ac-legend">
        <span class="legend-label">Legenda</span>
        <span class="legend-item"><span class="swatch ok"></span> OK</span>
        <span class="legend-item"><span class="swatch wait"></span> in attesa</span>
        <span class="legend-item"><span class="swatch warn"></span> da completare</span>
        <span class="legend-item"><span class="swatch crit"></span> bloccante</span>
        <span class="legend-item"><span class="swatch na"></span> n/a</span>
    </div>

    <div class="mt-10">
        <div class="ac-section-head">
            <h2>Scadenze / criticità</h2>
        </div>
        <div class="ac-side-list">
            @for (e of scadenze; track e.id) {
                <div class="ac-side-row" (click)="openEvento(e.id)">
                    <div class="ac-side-time">{{ e.dal | date: 'dd/MM/yy' }}</div>
                    <div>
                        <strong>{{ e.evento }}</strong>
                        <div class="text-sm" [ngClass]="{'text-red-600': e.summary.level === 'crit', 'text-amber-600': e.summary.level === 'warn'}">{{ e.summary.text }}</div>
                    </div>
                </div>
            } @empty {
                <div class="ac-empty">Nessuna criticità aperta.</div>
            }
        </div>
    </div>
</section>
}

<!-- ============ COMPAGNIE ============ -->
@if (!loading && section === 'compagnie') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Compagnie ospiti</h2>
        <span class="ac-meta">{{ compagnieFiltrate.length }} in elenco</span>
    </div>

    <div class="ac-toolbar">
        <input type="text" pInputText class="w-full" placeholder="Cerca compagnia, evento…" [(ngModel)]="filterSearch" />
        <div class="ac-pills">
            <button type="button" class="ac-pill" [class.active]="filterPeriod === '14'" (click)="setPeriod('14')">14 GG</button>
            <button type="button" class="ac-pill" [class.active]="filterPeriod === '90'" (click)="setPeriod('90')">90 GG</button>
            <button type="button" class="ac-pill" [class.active]="filterPeriod === 'stagione'" (click)="setPeriod('stagione')">stagione</button>
            <span class="ac-pill-sep"></span>
            <button type="button" class="ac-pill" [class.active]="filterState === 'all'" (click)="setState('all')">tutte</button>
            <button type="button" class="ac-pill" [class.active]="filterState === 'crit'" (click)="setState('crit')">criticità</button>
            <button type="button" class="ac-pill" [class.active]="filterState === 'ok'" (click)="setState('ok')">pronte</button>
        </div>
    </div>

    <div class="ac-events-list">
        @for (e of compagnieFiltrate; track e.id) {
            <button type="button" class="ac-event-row" (click)="openEvento(e.id)">
                <div class="ac-event-date text-center">
                    <strong>{{ e.dal | date: 'dd' }}</strong>
                    <span>{{ e.dal | date: 'MMM/yy' | uppercase }}</span>
                </div>
                <div class="ac-event-title">
                    {{ e.evento }}
                    <span class="sub">{{ e.ragione_sociale }} · {{ e.n_personale }} lavoratori · {{ e.n_subappalti }} subappalti</span>
                </div>
                <div class="ac-status-bar">
                    <div [class]="statusClass(e.status.doc)">Doc</div>
                    <div [class]="statusClass(e.status.pers)">Pers</div>
                    <div [class]="statusClass(e.status.imp)">Imp</div>
                    <div [class]="statusClass(e.status.sub)">Sub</div>
                </div>
                <div class="ac-event-summary" [ngClass]="e.summary.level">{{ e.summary.text }}</div>
                <div class="ac-event-arrow">→</div>
            </button>
        } @empty {
            <div class="ac-empty">Nessuna compagnia trovata.</div>
        }
    </div>
</section>
}

<!-- ============ RUBRICA ============ -->
@if (!loading && section === 'rubrica') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Rubrica</h2>
        <div class="flex gap-2 flex-wrap">
            <button type="button" class="acc-btn" (click)="importRubrica()">Importa da eventi</button>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovaRubrica()">+ Nuova anagrafica</button>
        </div>
    </div>

    <div class="ac-toolbar">
        <input type="text" pInputText class="w-full" placeholder="Cerca ragione sociale, P.IVA, telefono, email…" [(ngModel)]="rubricaSearch" />
    </div>

    <p-table [value]="rubricaFiltrata" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="scheda-tabella p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="500">
        <ng-template pTemplate="header">
            <tr>
                <th>Ragione sociale</th>
                <th>P.IVA</th>
                <th>Referente</th>
                <th>Telefono</th>
                <th>Email</th>                
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-a>
            <tr>
                <td><span class="cell-nome">{{ a.ragione_sociale }}</span></td>
                <td>{{ a.piva || '—' }}</td>
                <td>{{ a.referente || '—' }}</td>
                <td>{{ a.telefono || '—' }}</td>
                <td>{{ a.email || '—' }}</td>                
                <td>
                    <div class="table-actions">
                        <i class="bi bi-pencil" (click)="openEditRubrica(a)"></i>
                        <i class="bi bi-trash" (click)="deleteRubrica($event, a)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr><td colspan="6">Nessuna anagrafica. Usa “Importa da eventi” o crea una nuova voce.</td></tr>
        </ng-template>
    </p-table>
</section>
}

<!-- Dialog Rubrica -->
<p-dialog [(visible)]="rubricaDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{width: '60vw'}" [header]="rubricaEdit ? 'Modifica anagrafica' : 'Nuova anagrafica'">
    <form [formGroup]="formRubrica" class="accrediti-form flex flex-col gap-4" (ngSubmit)="saveRubrica()">
        <div class="flex flex-col"><label>Ragione sociale *</label><input pInputText formControlName="ragione_sociale" /></div>
        <div class="flex gap-4">
            <div class="flex flex-col w-1/2"><label>P.IVA</label><input pInputText formControlName="piva" /></div>
            <div class="flex flex-col w-1/2"><label>Telefono</label><input pInputText formControlName="telefono" /></div>
        </div>
        <div class="flex flex-col"><label>Sede</label><input pInputText formControlName="sede" /></div>
        <div class="flex gap-4">
            <div class="flex flex-col w-1/2"><label>Referente</label><input pInputText formControlName="referente" /></div>
            <div class="flex flex-col w-1/2"><label>Email</label><input pInputText formControlName="email" /></div>
        </div>
        <div class="flex flex-col"><label>Note</label><textarea formControlName="note" rows="2"></textarea></div>
        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="rubricaDialog = false">Annulla</button>
            <button type="submit" class="acc-btn acc-btn-primary" [disabled]="formRubrica.invalid">Salva</button>
        </div>
    </form>
</p-dialog>

<!-- MODAL DOCUMENTI TEATRO -->
<p-dialog [visible]="documenti" styleClass="accrediti-dialog" [style]="{width: '50%'}" header="Gestisci documenti Teatro" [modal]="true" class="p-fluid" (visibleChange)="documenti = false">
    <ng-template pTemplate="content">
        <form [formGroup]="formDocumenti" (ngSubmit)="onDocumenti()" class="accrediti-form flex flex-col gap-8">
            <div class="w-full flex flex-col gap-3">
                <label>Scheda Tecnica</label>
                <app-file-upload #uploadSchedaTecnica [form]="formDocumenti" [control]="'scheda_tecnica'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                @if ((configurazione?.scheda_tecnica || '').toString().length > 0) {
                    <div class="doc-row ok mt-1">
                        <div class="doc-info">
                            <strong>Scheda Tecnica</strong>
                            <span class="doc-meta">caricato · clicca Apri per scaricare</span>
                        </div>
                        <span class="doc-stato ok">caricato</span>
                        <div class="doc-actions">
                            <button type="button" class="doc-btn" (click)="onDocumento((configurazione?.scheda_tecnica || '').toString())">Apri</button>
                            <button type="button" class="doc-btn doc-btn-danger" pTooltip="Rimuovi la scheda tecnica caricata" tooltipPosition="bottom" (click)="onOpenDeleteDocumento($event, 'scheda_tecnica')">Rimuovi</button>
                        </div>
                    </div>
                    <p-confirmpopup #deleteSchedaTecnica>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onCloseDeleteDocumento('scheda_tecnica')">Annulla</button>
                                    <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteDocumento('scheda_tecnica')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                }
            </div>
            <div class="w-full flex flex-col gap-3">
                <label>Duvri</label>
                <app-file-upload #uploadDuvri [form]="formDocumenti" [control]="'duvri'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                @if ((configurazione?.duvri || '').toString().length > 0) {
                    <div class="doc-row ok mt-1">
                        <div class="doc-info">
                            <strong>DUVRI</strong>
                            <span class="doc-meta">caricato · clicca Apri per scaricare</span>
                        </div>
                        <span class="doc-stato ok">caricato</span>
                        <div class="doc-actions">
                            <button type="button" class="doc-btn" (click)="onDocumento((configurazione?.duvri || '').toString())">Apri</button>
                            <button type="button" class="doc-btn doc-btn-danger" pTooltip="Rimuovi il DUVRI caricato" tooltipPosition="bottom" (click)="onOpenDeleteDocumento($event, 'duvri')">Rimuovi</button>
                        </div>
                    </div>
                    <p-confirmpopup #deleteDuvri>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onCloseDeleteDocumento('duvri')">Annulla</button>
                                    <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteDocumento('duvri')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                }
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="documenti = false">Annulla</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formDocumenti.valid">Modifica</button>
            </div>
        </form>
    </ng-template>
</p-dialog>

<p-confirmPopup />
